import { EdgeProps } from "@xyflow/react";
import { Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ButtonEdge } from "./ButtonEdge";
import { DataEdge } from "./DataEdge";
import { LabeledEdge, AdvancedEdgeData } from "./LabeledEdge";

// Wrapper for DataEdge to match ReactFlow EdgeProps
export const DataEdgeWrapper = (props: EdgeProps) => {
  return <DataEdge {...props} data={props.data as AdvancedEdgeData & Record<string, unknown> | undefined} />;
};

// Wrapper for LabeledEdge to match ReactFlow EdgeProps  
export const LabeledEdgeWrapper = (props: EdgeProps) => {
  return <LabeledEdge {...props} data={props.data as AdvancedEdgeData & Record<string, unknown> | undefined} />;
};

// Wrapper for ButtonEdge with configuration button
export const ButtonEdgeWrapper = (props: EdgeProps) => {
  const handleConfigClick = () => {
    console.log("Configure edge:", props.id);
    // TODO: Open edge configuration dialog
  };

  return (
    <ButtonEdge {...props}>
      <Button
        size="sm"
        variant="outline"
        onClick={handleConfigClick}
        className="h-6 w-6 p-0"
      >
        <Settings className="h-3 w-3" />
      </Button>
    </ButtonEdge>
  );
};
